<script setup lang="ts">
const { count = 1 } = defineProps<IProps>();
interface IProps {
    count: number;
}
</script>

<template>
    <div class="card-loaders-list">
        <template v-for="key in count" :key>
            <div class="card-skeleton loading-skeleton" />
        </template>
    </div>
</template>

<style lang="scss" scoped>
.card-skeleton {
    height: 150px;
    width: 100%;
    border-radius: 12px;
    margin: 4px 0;
}
</style>
